import { Avatar } from "@heroui/react";
import { ShieldCheckIcon, ShieldOffIcon } from "lucide-react";
import TransferCardElement from "../../assets/transfer-card-element.svg?react";
import type { ShieldingMode } from "./shieldingConfig";

export function ShieldingCard({
  shieldingMode,
  displayAmount,
  tokenSymbol,
}: {
  shieldingMode: ShieldingMode;
  displayAmount: number;
  tokenSymbol: string;
}) {
  // TODO: get token address as a prop
  // Derive the token symbol from the token address
  // TODO: get amount as bigint
  // TODO: fetch token decimals from the token address
  // derive the display amount from the amount and token decimals
  return (
    <div className="grid *:col-start-1 *:row-start-1 w-full">
      <TransferCardElement className="w-full" />
      <div className="flex items-center w-full">
        <div className="flex flex-col items-center flex-1">
          <div className="relative mb-2">
            <Avatar name="T" color="primary" className="size-10" />
            {shieldingMode === "shield" ? (
              <ShieldOffIcon className="absolute -bottom-2 -right-2 size-8 bg-[#33546C] rounded-full p-1 border-3 border-[#3F6784]" />
            ) : (
              <ShieldCheckIcon className="absolute -bottom-2 -right-2 size-8 bg-[#33546C] rounded-full p-1 border-3 border-[#3F6784] text-[#6DDDC1]" />
            )}
          </div>
          <span className="font-semibold">{shieldingMode === "shield" ? "Public balance" : "Private balance"}</span>
          <span className="text-small text-[#ADC0D0]">
            -{displayAmount} {tokenSymbol}
          </span>
        </div>
        <div className="basis-10" />
        <div className="flex flex-col items-center flex-1">
          <div className="relative mb-2">
            <Avatar name="T" color="primary" className="size-10" />
            {shieldingMode === "shield" ? (
              <ShieldCheckIcon className="absolute -bottom-2 -right-2 size-8 bg-[#33546C] rounded-full p-1 border-3 border-[#3F6784] text-[#6DDDC1]" />
            ) : (
              <ShieldOffIcon className="absolute -bottom-2 -right-2 size-8 bg-[#33546C] rounded-full p-1 border-3 border-[#3F6784]" />
            )}
          </div>
          <span className="font-semibold">{shieldingMode === "shield" ? "Private balance" : "Public balance"}</span>
          <span className="text-small text-[#ADC0D0]">
            +{displayAmount} {tokenSymbol}
          </span>
        </div>
      </div>
    </div>
  );
}
